<script>
export default {
  name: 'BaseClose',

  props: {
    href: {
      type: String,
      default: ''
    },
    isOverlay: {
      type: Boolean,
      default: false
    }
  },

  emits: ['click']
}
</script>

<template>
  <component
    :is="href.length ? 'a' : 'button'"
    :href="href.length ? href : false"
    :class="[
      'close',
      { 'close--inline': !isOverlay },
      { 'close--overlay': isOverlay }
    ]"
    @click.prevent="$emit('click')"
  >
    <span class="visually-hidden">close</span>
  </component>
</template>

<style scoped lang="scss">
@import '../scss/utils/variables';
@import '../scss/utils/colors';

.close {
  background-color: $color-background;
  border: 1px solid;
  overflow: hidden;
  &:before,
  &:after {
    content: '';
    display: block;
    position: absolute;
    width: 100%;
    left: 50%;
    top: 50%;
    background-color: currentColor;
    transition: transform $transition-duration $ease;
  }
  &:before {
    transform: translate(-50%, -50%) rotate(45deg);
  }
  &:after {
    transform: translate(-50%, -50%) rotate(-45deg);
  }
  &:focus {
    outline: none;
  }
  html:not(.touchevents) &:hover,
  &:focus {
    &:before {
      transform: translate(-50%, -50%) rotate(0deg);
    }
    &:after {
      transform: translate(-50%, -50%) rotate(0deg);
    }
  }
  &--overlay {
    position: fixed;
    top: $width-gutter;
    right: $width-gutter;
    width: $size-close;
    height: $size-close;
    border-radius: 50%;
    z-index: 9;
    &:before,
    &:after {
      width: 60%;
      height: 2px;
    }
  }
  &--inline {
    position: relative;
    min-width: calc(#{$width-gutter-double} + 1em);
    padding: $width-gutter-half $width-gutter;
    border-radius: $border-radius;
    background-color: $color-light;
    border-color: $color-light;
    &:before,
    &:after {
      width: 1em;
      height: 1px;
    }
  }
}

@media screen and (max-width: $max-width-mobile) {
  .close {
    &--overlay {
      top: $width-gutter-mobile;
      right: $width-gutter-mobile;
      width: $size-close-mobile;
      height: $size-close-mobile;
    }
    &--inline {
      padding: $width-gutter-mobile-half $width-gutter-mobile;
      border-radius: $border-radius-mobile;
    }
  }
}
</style>